// import PropTypes from 'prop-types';
import React, {useState, useCallback, useEffect} from 'react'
import {WebUI, getNid, prefix as componentPrefix} from '../../wui-core/src/index'
import InputNumber from './InputNumber'
import {InputNumberGroupProps} from './iInputNumberGroup'
import classnames from 'classnames'

const noop = () => {}

const defaultProps = {
    clsPrefix: 'u-input-number',
    className: '',
    placeholder: ['', ''],
    onChange: noop,
    onBlur: noop,
    onFocus: noop
}

const InputNumberGroup: React.FC<InputNumberGroupProps> = (props) => {
    const [value, setValue] = useState<[number | string | undefined, number | string | undefined]>(
        props.value || ['', '']
    )

    useEffect(() => {
        if ('value' in props) {
            if (Array.isArray(props.value)) {
                setValue(props.value)
            } else if (!props.value) {
                setValue(['', ''])
            }
        }
    }, [props.value])

    const onChange = useCallback((index: number, v: number) => {
        setValue(prevValue => {
            const newValue: [number | string | undefined, number | string | undefined] = [...prevValue]
            newValue[index] = v
            props.onChange?.(newValue)
            return newValue
        })
    }, [props.onChange])

    const onFocus = useCallback((index: number, v: number) => {
        setValue(prevValue => {
            const newValue: [number | string | undefined, number | string | undefined] = [...prevValue]
            newValue[index] = v
            props?.onFocus?.(newValue)
            return newValue
        })
    }, [props.onFocus])

    const onBlur = useCallback((index: number, v: number) => {
        setValue(prevValue => {
            if (index === 1) {
                if ((prevValue[0] || prevValue[0] === 0) && v < +prevValue[0]) {
                    console.warn('The second value must be greater than or equal to the first value')
                }
            }
            const newValue: [number | string | undefined, number | string | undefined] = [...prevValue]
            newValue[index] = v
            props?.onBlur?.(newValue)
            return newValue
        })
    }, [props.onBlur])

    const renderBrowser = useCallback((propsValue: any) => {
        const { browserStyle, bordered, browserClassName, clsPrefix, placeholder, size, ...other } = props

        const wrapperCls = classnames(`${componentPrefix}-component-browser`, {
            [`${componentPrefix}-component-browser-border-bottom`]: bordered === 'bottom',
            [`${componentPrefix}-component-browser-${size}`]: !!size
        })

        const componentCls = classnames(`${clsPrefix}-group-browser`, {
            [`${browserClassName}`]: browserClassName,
        })
        return (
            <div className={wrapperCls}>
                <div className={componentCls} style={browserStyle}>
                    {
                        propsValue ? <>
                            {propsValue && propsValue[0] &&
                                <InputNumber
                                    {...other}
                                    browser
                                    returnBrowserValue
                                    onChange={(val: number) => {
                                        onChange(0, val)
                                    }}
                                    onBlur={(val: number) => {
                                        onBlur(0, val)
                                    }}
                                    onFocus={(val: number) => {
                                        onFocus(0, val)
                                    }}
                                    value={value[0]}
                                    placeholder={(placeholder as InputNumberGroupProps['placeholder'])?.[0]}
                                />}
                            ~
                            {propsValue && propsValue[1] && <InputNumber
                                {...other}
                                browser
                                returnBrowserValue
                                onChange={(val: number) => {
                                    onChange(1, val)
                                }}
                                onBlur={(val: number) => {
                                    onBlur(1, val)
                                }}
                                onFocus={(val: number) => {
                                    onFocus(1, val)
                                }}
                                value={value[1]}
                                placeholder={(placeholder as InputNumberGroupProps['placeholder'])?.[1]}
                            />
                            }
                        </> : <span>--</span>
                    }
                </div>
            </div>
        )
    }, [props, value, onChange, onBlur, onFocus])

    const {className, clsPrefix, value: propsValue, placeholder, split, id, browser, ...other} = props
    const adapterNid = getNid(props)

    // 浏览态
    if (browser) {
        return renderBrowser(propsValue)
    }

    return (
        <div className={`${clsPrefix}-group ${className}`} id={id} {...adapterNid} /* id不能下传到Input，否则将存在两个相同id */>
            <InputNumber
                {...other}
                onChange={(val: number) => {
                    onChange(0, val)
                }}
                onBlur={(val: number) => {
                    onBlur(0, val)
                }}
                onFocus={(val: number) => {
                    onFocus(0, val)
                }}
                value={value[0]}
                placeholder={(placeholder as InputNumberGroupProps['placeholder'])?.[0]}
            />
            {split ? split : <span className={`${clsPrefix}-group-split`}>~</span>}
            <InputNumber
                {...other}
                onChange={(val: number) => {
                    onChange(1, val)
                }}
                onBlur={(val: number) => {
                    onBlur(1, val)
                }}
                onFocus={(val: number) => {
                    onFocus(1, val)
                }}
                value={value[1]}
                placeholder={(placeholder as InputNumberGroupProps['placeholder'])?.[1]}
            />
        </div>
    )
}

InputNumberGroup.displayName = 'InputNumberGroup'

export default WebUI({name: 'input-number', defaultProps})(InputNumberGroup)
